import { X } from 'lucide-react';
import { useI18n } from '@/i18n';
import { TaskCreateForm, type TaskCreateMode, type TaskCreatePrefillValues } from './TaskCreatePage';

type TaskCreateModalProps = {
  open: boolean;
  onClose: () => void;
  onCreated?: () => void;
  initialValues?: TaskCreatePrefillValues;
  mode?: TaskCreateMode;
  sourceTaskUuidId?: string;
  sourceTaskLabel?: string;
};

export default function TaskCreateModal({
  open,
  onClose,
  onCreated,
  initialValues,
  mode = 'default',
  sourceTaskUuidId,
  sourceTaskLabel,
}: TaskCreateModalProps) {
  const { t } = useI18n();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/45 p-4 backdrop-blur-sm">
      <div className="relative max-h-[92vh] w-full max-w-4xl overflow-y-auto rounded-3xl bg-white p-4 shadow-2xl md:p-6">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 rounded-lg border border-gray-200 p-2 text-gray-500 hover:bg-gray-50"
          aria-label={t('common.close')}
        >
          <X className="h-4 w-4" />
        </button>
        <TaskCreateForm
          modal
          showCloseButton={false}
          onCancel={onClose}
          initialValues={initialValues}
          mode={mode}
          sourceTaskUuidId={sourceTaskUuidId}
          sourceTaskLabel={sourceTaskLabel}
          onCreated={() => {
            onCreated?.();
            onClose();
          }}
        />
      </div>
    </div>
  );
}
